// Expand accordions page load that are marked as expanded
jQuery('.panel[data-expanded] .collapse').collapse('show')



// WEBPACK FOOTER //
// ./src/components/accordion/scripts.js